export default "__VITE_ASSET__o$e1KPze__"